import {
  TRUE_AUTH_SOURCE,
  TRUE_RETAIL_AUTH,
  OKTA_CACHE_STORAGE,
  OKTA_TOKEN_STORAGE,
  OKTA_OAUTH_REDIRECT_PARAMS,
  OKTA_PKCE_STORAGE,
} from "../constants/common";

const authObjectName = TRUE_RETAIL_AUTH;

const localStorageService = {
  login: (accessToken, refreshToken, tokenTimeout, prn, source) => {
    const authObject = {
      accessToken,
      refreshToken,
      tokenTimeout,
      prn,
    };
    localStorage.setItem(authObjectName, JSON.stringify(authObject));
    if (source) localStorage.setItem(TRUE_AUTH_SOURCE, source);
    sessionStorage.activeSession = true;
  },
  refreshRetailToken: (accessToken, refreshToken, tokenTimeout) => {
    const authObjectString = localStorage.getItem(authObjectName);
    if (authObjectString) {
      const authObject = JSON.parse(authObjectString);
      authObject.accessToken = accessToken;
      authObject.refreshToken = refreshToken;
      authObject.tokenTimeout = tokenTimeout
      localStorage.setItem(authObjectName, JSON.stringify(authObject));
    }
  },
  logout: () => {
    localStorage.removeItem(authObjectName);
    localStorage.removeItem(TRUE_AUTH_SOURCE);
    localStorage.removeItem(OKTA_CACHE_STORAGE);
    localStorage.removeItem(OKTA_TOKEN_STORAGE);
    localStorage.removeItem(OKTA_OAUTH_REDIRECT_PARAMS);
    localStorage.removeItem(OKTA_PKCE_STORAGE);
    sessionStorage.activeSession = false;
  },

  getAuthToken: () => {
    const authObjectString = localStorage.getItem(authObjectName);
    if (authObjectString) {
      const authObject = JSON.parse(authObjectString);
      if (authObject.accessToken) return authObject.accessToken;
      return null;
    }
    return null;
  },
  getOktaAuth: () => {
    return localStorage.getItem(OKTA_TOKEN_STORAGE);
  },
  getAuthSource: () => {
    return localStorage.getItem(TRUE_AUTH_SOURCE);
  },
  getRefreshToken: () => {
    const authObjectString = localStorage.getItem(authObjectName);
    if (authObjectString) {
      const authObject = JSON.parse(authObjectString);
      if (authObject.refreshToken) return authObject.refreshToken;
      return null;
    }
    return null;
  },
  getTokenTimeout: () => {
    const authObjectString = localStorage.getItem(authObjectName);
    if (authObjectString) {
      const authObject = JSON.parse(authObjectString);
      if (authObject.tokenTimeout) return authObject.tokenTimeout;
      return null;
    }
    return null;
  },
  getStoreId: () => {
    const storeId = {
      country: localStorage.getItem('trueStoreId.country'),
      storeNumber: localStorage.getItem('trueStoreId.storeNumber'),
      imageUrl: localStorage.getItem('trueStoreId.imageUrl'),
    };
    return storeId;
  },
  setStoreId: (country, storeNumber, imageUrl) => {
    localStorage.setItem('trueStoreId.country', country);
    localStorage.setItem('trueStoreId.storeNumber', storeNumber);
    localStorage.setItem('trueStoreId.imageUrl', imageUrl);  //  Confirm if trueStoreId.imageUrl is not being used and delete if not in use
  },
  getLanguage: () => {
    const language = {
      i18nLanguageCode: localStorage.getItem('rlLanguage.i18nLanguageCode'),
      ncssLanguageCode: localStorage.getItem('rlLanguage.ncssLanguageCode'),
    };
    return language;
  },
  setLanguage: (i18nLanguageCode, ncssLanguageCode) => {
    localStorage.setItem('rlLanguage.i18nLanguageCode', i18nLanguageCode);
    localStorage.setItem('rlLanguage.ncssLanguageCode', ncssLanguageCode);
  },
}

export default localStorageService;